<div class="container">
	<h1>Hantera tidsbok</h1>
	<app-time-slot-index (deletedTimeSlot)="deleteTimeSlot($event)"></app-time-slot-index>
</div>
